<template>
    <div v-if="obj.id" style="width:900px;margin:0 auto;">
        <!-- <pdf417 :data="obj.dossier.dossierNo" @pdfImg="getImagePdf417"></pdf417> -->
        <div class=" tar">
            <el-button size="mini" pain @click="closeHandle">返回</el-button>
            <el-button size="mini" type="primary" class="results" @click="printHandle">打印</el-button>
            <el-button size="mini" type="primary" @click="pdfHandle">生成PDF</el-button>
        </div>
        <div ref="printwrap" v-if="img">
            <img :src="img" style="width:100%;height:auto;">
        </div>
        <div style="padding-top:20px;" v-if="!img">
            <div class="pdf-wrapper breakable" id="page1" ref="wrap">
                <div class="water-wrap" v-watermark="{text:deptName+'-公益醒目信息化管理系统'}"></div>
                <div class="pdf-header">
                    <div>
                        <img src="/img/bg/logo4.png" class="logo">
                        <!-- <div class="logo-title">预防青少年违法犯罪系统</div> -->
                    </div>
                    <!-- <div class="txm-container df">
                        <div class="label">流水号</div>
                        <div class="txm"><img :src="pdfImg" /></div>
                    </div> -->
                    <div class="txm-container">
                        <!-- <div class="label">流水号</div> -->
                        <div class="txm">
                            <pdf417 :data="obj.basisArchiveNo" @pdfImg="getImagePdf417"></pdf417>
                        </div>
                        <div class="label" v-html="strInit(obj.basisArchiveNo)"></div>
                    </div>
                </div>
                <div class="num-family" v-html="strInit(obj.basisArchiveNo)"></div>
                <div class="pdf-title">{{obj.basisArchivePersonalData.name}}基础档案</div>
                <div class="mb20">根据关于印发《关于晋安区未成年人综合保护工作的实施方案》的通知 晋检发[2021]3号文件有关内容转办该文件，请给予执行。 </div>
                <avue-form :option="option" v-model="obj">
                    <template slot="info">
                        <div class="two-line">
                            <div class="line df">
                                <div class="t-label">户籍地址</div>
                                <div class="t-content">{{obj.basisArchivePersonalData.residenceProvince}}{{obj.basisArchivePersonalData.residenceCity}}{{obj.basisArchivePersonalData.residenceDistrict}}{{obj.basisArchivePersonalData.residenceAddress}}</div>
                            </div>
                            <div class="line df">
                                <div class="t-label">现住地址</div>
                                <div class="t-content">{{obj.basisArchivePersonalData.actualResidenceProvince}}{{obj.basisArchivePersonalData.actualResidenceCity}}{{obj.basisArchivePersonalData.actualResidenceDistrict}}{{obj.basisArchivePersonalData.actualResidentialAddress}}</div>
                            </div>
                        </div>
                    </template>
                    <!-- 头像 -->
                    <template slot="photoUrl">
                        <div class="t-content">
                            <el-image style="width: 100px; height: 100px" :src="obj.basisArchivePersonalData.photoUrl" fit="contain"></el-image>
                        </div>
                    </template>

                    <!-- 户籍地址 -->
                    <template slot="residenceAddress">
                        <div class="t-content">{{obj.basisArchivePersonalData.residenceProvince}}{{obj.basisArchivePersonalData.residenceCity}}{{obj.basisArchivePersonalData.residenceDistrict}}{{obj.basisArchivePersonalData.residenceAddress}}</div>
                    </template>
                    <!-- 现住地址 -->
                    <template slot="actualResidentialAddress">
                        <div class="t-content">{{obj.basisArchivePersonalData.actualResidenceProvince}}{{obj.basisArchivePersonalData.actualResidenceCity}}{{obj.basisArchivePersonalData.actualResidenceDistrict}}{{obj.basisArchivePersonalData.actualResidentialAddress}}</div>
                    </template>
                    <!-- 就学状态 -->
                    <template slot="studentStatus" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchivePersonalData.studentStatus)}} {{obj.basisArchivePersonalData.school}}{{obj.basisArchivePersonalData.theGrade}}{{obj.basisArchivePersonalData.theClass}} {{obj.basisArchivePersonalData.studentNo}}</div>
                    </template>
                    <!-- 就业状态 -->
                    <template slot="employmentStatus" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchivePersonalData.employmentStatus)}} {{obj.basisArchivePersonalData.employmentUnit}}</div>
                    </template>

                    <!-- 亲属关系 -->
                    <template slot="basisArchiveKinshipList" slot-scope="scope">
                        <div class="t-content">
                            <avue-crud :data="obj.basisArchiveKinshipList" :option="kinshipOption"></avue-crud>
                        </div>
                    </template>
                    <!-- 走访记录 -->
                    <template slot="basisArchiveInterviewList" slot-scope="scope">
                        <div class="t-content">
                            <div v-for="(item,index) in obj.basisArchiveInterviewList" :key="index" class="detail-i">
                                <div>走访类型:{{getLabel(item.interviewType,"visit-tracking_method")}}</div>
                                <div>走访时间:{{item.visitTime}}</div>
                                <div>记录人:{{item.createUserName}}</div>
                                <div>内容:{{item.content}}</div>
                                <div v-for="(img,n) in item.imgUrls" :key="n">
                                    <img :src="img">
                                </div>
                            </div>
                            <!-- <avue-crud :data="obj.basisArchiveInterviewList" :option="recordOption"></avue-crud> -->
                        </div>
                    </template>
                    <!-- 人际关系 -->
                    <template slot="basisArchiveRelationList" slot-scope="scope">
                        <div class="t-content">
                            <avue-crud :data="obj.basisArchiveRelationList" :option="relationOption"></avue-crud>
                        </div>
                    </template>
                    <!-- 曾使用服务 -->
                    <template slot="isServiceSituation" slot-scope="scope">
                        <div class="t-content">
                            <div class="t-content">{{getValues(scope.dic,obj.basisArchivePersonalData.isServiceSituation)}} {{obj.basisArchivePersonalData.serviceSituationRemarks}}</div>
                        </div>
                    </template>
                    <!-- 现使用服务 -->
                    <template slot="serviceSituationRecord" slot-scope="scope">
                        <div class="t-content">
                            <div class="t-content">{{getValues(scope.dic,obj.basisArchivePersonalData.serviceSituationRecord)}} {{obj.basisArchivePersonalData.serviceSituationNow}}</div>
                        </div>
                    </template>
                    <!-- 需求跟进 -->
                    <template slot="needTo" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.needTo)}} {{obj.needToRemark}}</div>
                    </template>
                    <!-- 危险因素 -->
                    <template slot="criticalFactors" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.criticalFactors)}} {{obj.criticalFactorsRemark}}</div>
                    </template>
                    <!-- 紧急服务 -->
                    <template slot="emergencyService" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.emergencyService)}} {{obj.emergencyServiceRemark}}</div>
                    </template>
                    <!-- 个案来源 -->
                    <template slot="source" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.source)}} {{obj.sourceRemark}}</div>
                    </template>
                    <!-- 情绪问题 -->
                    <template slot="emotionalProblems" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.emotionalProblems)}} {{obj.basisArchiveProblem.moodRemarks}}</div>
                    </template>
                    <!-- 住宿安排 -->
                    <template slot="arranging" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.arranging)}} {{obj.basisArchiveProblem.arrangingRemark}}</div>
                    </template>
                    <!-- 不良嗜好 -->
                    <template slot="badAddiction" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.badAddiction)}} {{obj.basisArchiveProblem.badAddictionRemark}}</div>
                    </template>
                    <!-- 行为问题 -->
                    <template slot="behaviorProblems" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.behaviorProblems)}} {{obj.basisArchiveProblem.behaviorProblemsRemark}}</div>
                    </template>
                    <!-- 儿童照顾 -->
                    <template slot="childCare" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.childCare)}} {{obj.basisArchiveProblem.childCareRemark}}</div>
                    </template>
                    <!-- 是否有犯罪前科 -->
                    <template slot="criminalRecord" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.criminalRecord)}} {{obj.basisArchiveProblem.criminalRecordRemark}}</div>
                    </template>
                    <!-- 家庭暴力 -->
                    <template slot="domesticViolence" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.domesticViolence)}} {{obj.basisArchiveProblem.domesticViolenceRemark}}</div>
                    </template>
                    <!-- 家庭照料情况 -->
                    <template slot="employmentService" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.employmentService)}} {{obj.basisArchiveProblem.employmentServiceRemark}}</div>
                    </template>
                    <!-- 是否经常出入娱乐场所 -->
                    <template slot="entertainmentVenues" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.entertainmentVenues)}} {{obj.basisArchiveProblem.entertainmentVenuesRemark}}</div>
                    </template>
                    <!-- 是否有打架经历 -->
                    <template slot="fightExperience" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.fightExperience)}} {{obj.basisArchiveProblem.fightExperienceRemark}}</div>
                    </template>
                    <!-- 经济援助 -->
                    <template slot="financialAid" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.financialAid)}} {{obj.basisArchiveProblem.financialAidRemark}}</div>
                    </template>
                    <!-- 健康问题 -->
                    <template slot="healthProblems" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.healthProblems)}} {{obj.basisArchiveProblem.healthProblemsRemark}}</div>
                    </template>
                    <!-- 住房安排 -->
                    <template slot="housingArrangement" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.housingArrangement)}} {{obj.basisArchiveProblem.housingArrangementRemark}}</div>
                    </template>
                    <!-- 在校处分情况 -->
                    <template slot="isDisciplinary" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.isDisciplinary)}} {{obj.basisArchiveProblem.isDisciplinaryRemark}}</div>
                    </template>
                    <!-- 是否喜欢网络游戏 -->
                    <template slot="isOnlineGame" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.isOnlineGame)}} {{obj.basisArchiveProblem.isOnlineGameRemark}}</div>
                    </template>
                    <!-- 法律法规认知程度 -->
                    <template slot="isRegulations" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.isRegulations)}} {{obj.basisArchiveProblem.isRegulationsRemark}}</div>
                    </template>
                    <!-- 是否有旷课行为 -->
                    <template slot="isTruancy" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.isTruancy)}} {{obj.basisArchiveProblem.isTruancyRemark}}</div>
                    </template>
                    <!-- 是否司法矫正、安置帮教 -->
                    <template slot="judicialPlacement" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.judicialPlacement)}} {{obj.basisArchiveProblem.judicialPlacementRemark}}</div>
                    </template>
                    <!-- 学习问题 -->
                    <template slot="learningProblems" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.learningProblems)}} {{obj.basisArchiveProblem.learningProblemsRemark}}</div>
                    </template>
                    <!-- 婚恋问题 -->
                    <template slot="marriageProblems" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.marriageProblems)}} {{obj.basisArchiveProblem.marriageProblemsRemark}}</div>
                    </template>
                    <!-- 是否夜不归宿行为 -->
                    <template slot="nightOut" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.nightOut)}} {{obj.basisArchiveProblem.nightOutRemark}}</div>
                    </template>
                    <!-- 其他 -->
                    <template slot="other" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.other)}} {{obj.basisArchiveProblem.otherRemark}}</div>
                    </template>
                    <!-- 政策咨询 -->
                    <template slot="policyConsultation" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.policyConsultation)}} {{obj.basisArchiveProblem.policyConsultationRemark}}</div>
                    </template>
                    <!-- 是否有纹身 -->
                    <template slot="tattoo" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.tattoo)}} {{obj.basisArchiveProblem.tattooRemark}}</div>
                    </template>
                    <!-- 作息时间 -->
                    <template slot="workTime" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchiveProblem.workTime)}} {{obj.basisArchiveProblem.workTimeRemark}}</div>
                    </template>
                    <template slot="tb">
                        <div class="two-line">
                            <div class="line df">
                                <div class="t-label">填表社工</div>
                                <div class="t-content">{{obj.fillName}}</div>
                            </div>
                            <div class="line df">
                                <div class="t-label">填表日期</div>
                                <div class="t-content">{{obj.fillDay}}</div>
                            </div>
                        </div>
                    </template>
                    <template slot="dd">
                        <div class="two-line">
                            <div class="line df">
                                <div class="t-label">督导签字</div>
                                <div class="t-content">{{obj.supervisionSignature}}</div>
                            </div>
                            <div class="line df">
                                <div class="t-label">批阅日期</div>
                                <div class="t-content">{{obj.supervisionDay}}</div>
                            </div>
                        </div>
                    </template>
                    <!-- 学习经历 -->
                    <template slot="studyExperience" slot-scope="scope">
                        <div class="t-content">{{obj.basisArchivePersonalData.studyExperience}}</div>
                    </template>
                    <!-- 综合特质 -->
                    <template slot="comprehensive" slot-scope="scope">
                        <div class="t-content">{{obj.basisArchivePersonalData.comprehensive}}</div>
                    </template>
                </avue-form>
                <!-- <div class="mt10">参与机构:</div> -->
                <div class="tar pdf-footer">
                    <div>公益项目信息化管理系统</div>
                    <div class="mt20">{{getDateFormate()}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { kinshipOption, relationOption } from "@/option/pdf/table";
import option from '@/option/pdf/archive'
import { previewImg,downloadPDF } from "@/util/pdf"
import mixin from './mixin'
export default {
    mixins: [mixin],
    props: {
        type: {
            type: Number,
            default: 1 // 一是基础档案 2是案件档案
        }
    },
    data() {
        return {
            option: option,
            kinshipOption: kinshipOption,
            // recordOption: recordOption,
            relationOption: relationOption
        }
    },
    methods: {
        pdfHandle() {
            if (!this.img) {
                previewImg(this.$refs.wrap).then(res => {
                    this.img = res
                    downloadPDF(this.$refs.printwrap, this.obj.basisArchivePersonalData.name + '-基础档案')
                })
            } else {
                downloadPDF(this.$refs.printwrap, this.obj.basisArchivePersonalData.name + '-基础档案')
            }

        }
    }
};

</script>
<style lang="scss">
@import "@/styles/moudles/pdf.scss";

</style>
